import hyperHTML from 'hyperhtml';

class HeaderTemplate {
  constructor(node) {
    this._element = node;
    this._render = hyperHTML.bind(node);
  }

  render(label) {
    this._render`${label}`;
  }

  get element() {
    return this._element;
  }
}

export default HeaderTemplate;
